module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/lead_image1-09b686dc59b43dd79c0aa19e9ad9acc2.jpg";